import { render, staticRenderFns } from "./DialogAddNewSection.vue?vue&type=template&id=5ecc286a&scoped=true"
import script from "./DialogAddNewSection.vue?vue&type=script&lang=js"
export * from "./DialogAddNewSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecc286a",
  null
  
)

export default component.exports